module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("ibdG4"))).then(() => parcelRequire('d0iPb'));